import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Youtube } from "@cinch-labs/design-system";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import { formatVideoSchema } from "../json-ld-script";
import { JsonLdScript } from "../json-ld-script/json-ld-script";
import { Heading } from "../shared/heading/heading";
import { Text } from "../shared/text/text";
import styles from "./video.module.css";
import Head from "next/head";
export var Video = function(_param) {
    var videoId = _param.videoId, title = _param.title, thumbnail = _param.thumbnail, description = _param.description, rest = _object_without_properties(_param, [
        "videoId",
        "title",
        "thumbnail",
        "description"
    ]);
    var trackEvent = useAnalytics().trackEvent;
    var videoStyles = {
        inner: styles.videoContainer,
        container: description && title ? styles.descriptionVideoMargin : styles.videoMargin
    };
    var sendVideoEvent = function() {
        return trackEvent({
            eventName: "Video click - ".concat(window.location.pathname),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "video",
                    label: "thumbnail",
                    action: "latest video"
                }
            }
        });
    };
    var schemaData = {
        videoId: videoId,
        title: title,
        thumbnail: thumbnail,
        description: description
    };
    return videoId ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                children: /*#__PURE__*/ _jsx(JsonLdScript, {
                    schema: formatVideoSchema(schemaData),
                    tagId: "JargonPage"
                })
            }),
            title && /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            description && /*#__PURE__*/ _jsx(Text, {
                children: description
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: videoStyles,
                children: /*#__PURE__*/ _jsx(Youtube, _object_spread({
                    videoId: videoId,
                    title: title || "",
                    className: styles.video,
                    customThumbnail: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.filename,
                    buttonLabel: "Play video",
                    showNewPlayIcon: true,
                    onClick: sendVideoEvent
                }, rest))
            })
        ]
    }) : null;
};
export default Video;
